var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsPulseRectangle01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1512 43.4621C7.24124 40.5522 7.24124 35.8671 7.24124 26.5015C7.24124 17.1358 7.24124 12.4507 10.1512 9.5408C13.0611 6.63086 17.7462 6.63086 27.1118 6.63086C36.4775 6.63086 41.1626 6.63086 44.0725 9.5408C46.9824 12.4507 46.9825 17.1358 46.9825 26.5015C46.9825 35.8671 46.9824 40.5522 44.0725 43.4621C41.1626 46.3721 36.4775 46.3721 27.1118 46.3721C17.7462 46.3721 13.0611 46.3721 10.1512 43.4621Z",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7609 26.5013H17.1766L20.4883 20.9817L23.8001 30.917L28.2158 17.6699L32.6315 35.3327L37.0472 26.5013H41.4629",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsPulseRectangle01);
export default __webpack_public_path__ + "static/media/hugeicons_pulse-rectangle-01.b7e624c914276253acb9f51e9b3164e0.svg";
export { ForwardRef as ReactComponent };